export default __webpack_public_path__ + "87a7dce199b998beec041ad585e1bd67.png";